var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "bottom" },
    [
      _c(
        "el-tabs",
        {
          attrs: { type: "card" },
          model: {
            value: _vm.activeName,
            callback: function ($$v) {
              _vm.activeName = $$v
            },
            expression: "activeName",
          },
        },
        [
          _vm._l(_vm.componentConfig, function (item, index) {
            return [
              _c("el-tab-pane", {
                key: index,
                attrs: { label: item.label, name: item.compName },
              }),
            ]
          }),
        ],
        2
      ),
      _c(_vm.activeName, { key: _vm.activeName, tag: "component" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }